import HttpRequest from "@/../bower_components/teknisavuecomponents/assets/utils/HttpRequest";
import SnackbarUtils from '@/../bower_components/teknisavuecomponents/assets/utils/SnackbarUtils';
import store from '../../../store/store';

class ReconhecimentoFacialController {

  public static async encodaImagem(
    base64Image: string,
  ) {
    const nrOrg = store.getters.user.nrorg;

    const route = 'encodaImagem';

    const params = {
      requestType: 'Row',
      NRORG: nrOrg,
      row: {
        FILE: base64Image,
      },
    };

    try {
      const response = await HttpRequest.post(route, params);
      const vinculos: any[] = response.data.dataset.data;

      return vinculos;

    } catch (err) {
      const errorMessage = 'Não foi possível gerar a hash Facial!';
      SnackbarUtils.showMessage(errorMessage, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async verificaRostoEncodaECompara(
    base64Image1: string,
    base64Image2: string,
  ) {
    const nrOrg = store.getters.user.nrorg;

    const route = 'verificaRostoEncodaECompara';

    const params = {
      requestType: 'Row',
      NRORG: nrOrg,
      row: {
        FILE1: base64Image1,
        FILE2: base64Image2,
      },
    };

    try {
      const response = await HttpRequest.post(route, params);
      const vinculos: any = response.data.dataset.data;

      if(vinculos && Array.isArray(vinculos) && vinculos[0].resultado) {
        return vinculos[0].resultado == true;
      }

      return false;

    } catch (err) {
      const errorMessage = 'Não foi possível validar a imagem!';
      SnackbarUtils.showMessage(errorMessage, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async saveHashFacial(
    nrParcNegocio: string,
    base64Image1: string,
  ) {
    const nrOrg = store.getters.user.nrorg;

    const route = 'saveHashFacial';

    const params = {
      requestType: 'Row',
      NRORG: nrOrg,
      row: {
        NRPARCNEGOCIO: nrParcNegocio,
        FILE: base64Image1
      },
    };

    try {
      const response = await HttpRequest.post(route, params);
      const vinculos: any[] = response.data.dataset.data;

      return vinculos;

    } catch (err) {
      const errorMessage = 'Não foi possível cadastrar a Biometria Facial';
      SnackbarUtils.showMessage(errorMessage, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async updateHashFacial(
    nrFaceId: string,
    nrParcNegocio: string,
    base64Image1: string,
  ) {
    const nrOrg = store.getters.user.nrorg;

    const route = 'updateHashFacial';

    const params = {
      requestType: 'Row',
      NRORG: nrOrg,
      row: {
        NRFACEID: nrFaceId, 
        NRPARCNEGOCIO: nrParcNegocio,
        FILE: base64Image1
      },
    };

    try {
      const response = await HttpRequest.post(route, params);
      const vinculos: any[] = response.data.dataset.data;

      return vinculos;

    } catch (err) {
      const errorMessage = 'Não foi possível atualizar a Biometria Facial';
      SnackbarUtils.showMessage(errorMessage, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async deleteHashFacial(
    nrFaceId: string,
    nrParcNegocio: string
  ) {
    const nrOrg = store.getters.user.nrorg;

    const route = 'deleteHashFacial';

    const params = {
      requestType: 'Row',
      NRORG: nrOrg,
      row: {
        NRFACEID: nrFaceId, 
        NRPARCNEGOCIO: nrParcNegocio
      },
    };

    try {
      const response = await HttpRequest.post(route, params);
      const vinculos: any[] = response.data.dataset.data;

      return vinculos;

    } catch (err) {
      const errorMessage = 'Não foi possível deletar a Biometria Facial';
      SnackbarUtils.showMessage(errorMessage, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  /** Retorna o NRVINCULOM do vínculo detectado ou null se não houverem correspondências. */
  public static async reconhecimentoFacial(
    base64Image: string,
    vinculosHashs: string,
  ): Promise<number | null> {
    const nrOrg = store.getters.user.nrorg;

    const route = 'reconhecimentoFacial';

    const params = {
      requestType: 'Row',
      NRORG: nrOrg,
      row: {
        HASHS_CONHECIDOS: vinculosHashs,
        FILE: base64Image
      },
    };

    try {
      const response = await HttpRequest.post(route, params);
      const vinculos: any = response.data.dataset.data;

      if(vinculos && Array.isArray(vinculos) && vinculos[0].resultado && vinculos[0].resultado !== 'Sem correspondências') {
        return vinculos[0].resultado;
      }

      return null;
    } catch (err) {
      const errorMessage = 'Não foi possível realizar o reconhecimento facial';
      //SnackbarUtils.showMessage(errorMessage, SnackbarUtils.TYPE_ERROR);

      //throw err;
    }
  }

  public static async getBiometriasVinculo(
    nrparcnegocio: string,
    showLoading = true
  ) {
    const route = 'getBiometriasVinculo';

    const nrOrg = store.getters.user.nrorg;

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
      NRPARCNEGOCIO: nrparcnegocio
    };

    try {
      const response = await HttpRequest.get(route, params, showLoading);
      const documentos: any[] = response.data.dataset.data;

      return documentos;
    } catch (err) {
      const message = 'Não foi possível carregar as Biometrias!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }
 
}

export default ReconhecimentoFacialController;
